import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const WarningFilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Style=Filled">
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3562 3.52971C13.1862 3.2108 12.8575 3.00838 12.4962 3.00025C12.1349 2.99213 11.7973 3.17955 11.6132 3.49051L2.13952 19.4905C1.9565 19.7996 1.95334 20.1831 2.13124 20.4952C2.30914 20.8073 2.64077 21 3 21H21C21.3512 21 21.6767 20.8158 21.8574 20.5146C22.0381 20.2135 22.0477 19.8397 21.8825 19.5297L13.3562 3.52971ZM12 15C12.5523 15 13 14.5523 13 14V11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V14C11 14.5523 11.4477 15 12 15ZM13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

WarningFilled.propTypes = {
  color: string,
  size: number,
};

WarningFilled.defaultProps = {
  color: N400,
  size: 20,
};

export default WarningFilled;
